import localeReducer from './reducers';

export * from './selectors';

export { default as types } from './types';

export { default as localeActions } from './actions';

export default localeReducer;
